<template>
    <v-dialog v-model="dialog" max-width="700" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="pt-5 pb-13 px-5">
            <v-row justify="end" class="ma-0">
                <v-btn icon>
                    <v-icon @click="dialog = false">mdi-close</v-icon>
                </v-btn>
            </v-row>

            <v-row justify="center" align="center" class="mx-0 mb-7 mt-5">
                <svg v-svg="'icon-settings'" size="28" class="mr-2"></svg>
                <h2 class="text-center">{{$t('teams.settings')}}</h2>
            </v-row>

            <div class="pa-4 tree-view">
                <v-progress-linear :indeterminate="true" v-if="loadingRequest"></v-progress-linear>

                <v-treeview :items="courses" hoverable v-else class="font-weight-bold black--text">
                    <template v-slot:prepend="{ item }">
                        <svg v-svg="'icon-settings-lesson'" size="15" v-if="item.type === 'lesson'"></svg>
                        <i :class="item.icon" v-else></i>
                    </template>

                    <template v-slot:append="{ item }">
                        <v-switch class="mb-0 mt-0"
                                  :input-value="Object.values(settings[item.type + 's']).find((data) => data[item.type + '_id'] === item.id) ? 1 : 0"
                                  @change="enableDisable(item.type, item.id, $event)"
                                  color="success"
                        >
                        </v-switch>
                    </template>
                </v-treeview>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['team_id'],
        data(){
            return {
                dialog: false,
                loadingRequest: false,
                loadingSave: false,
                settings: null,
                courses: [],
            }
        },

        watch: {
            'team_id': function (newVal) {
                if(newVal) {
                    this.getSettings();
                    this.getSubjects();
                }
            }
        },

        methods: {
            enableDisable(type, id, value){
                this.loadingSave = true;
                this.$api('teams').permissions({type, id, value, ...{team_id: this.team_id}}).then(() => {
                    this.$store.dispatch('alert', {type: 1, message: this.$t('global.success_edited')});
                }).finally(() => {
                    this.loadingSave = false;
                })
            },

            getSettings(){
                this.loadingRequest = true;
                this.$api('teams').settings(this.team_id).then((res) => {
                    this.settings = res.data.settings;
                    this.loadingRequest = false;
                })
            },

            getSubjects(){
                this.$api('subjects').getFullSubject({params: {team_id: this.team_id}}).then((res) => {
                    this.courses = res.data.courses;
                    this.courses.map((function (course) {
                        course.type = 'course';
                        course.children = course.lessons.map(function (lesson) {
                            lesson.name = lesson.title;
                            lesson.type = 'lesson';
                            return lesson;
                        });
                        return course;
                    }))
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/components/settings";
</style>